import React from "react";

const BannerSection = ({ heading, subheading, features, bannerp }) => {
  return (
    <section className="bg-[#800020] text-white py-10 px-4 md:py-12 md:px-6">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-center gap-6 md:gap-12">
        
        {/* Left Side: Heading, Subheading */}
        <div className="text-center lg:text-left max-w-lg flex flex-col justify-center md:ml-8 lg:w-1/2">
          <h2 className="text-2xl md:text-3xl font-bold leading-tight mb-1 md:mb-4">
            {heading}
          </h2>
          <p className="text-sm md:text-base text-gray-200  md:mb-6">
            {subheading}
          </p>
          <p className="text-sm text-center text-white md:text-xl  mb-2 mt-6">
             {bannerp} </p>
        </div>

        {/* Right Side: Features Grid with Icon beside Text */}
        <div className="lg:w-1/2 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 md:gap-6 mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 p-3 border border-gray-500 text-center rounded-lg bg-accent transition-transform transform hover:scale-105 hover:shadow-lg shadow-md"
            >
              <span className="text-2xl md:text-3xl">{feature.icon}</span>
              <p className="text-sm text-secondary md:text-base font-medium">
                {feature.text}
              </p>
            </div>
          ))}
        </div>

      </div>

      {/* Reserve Your Spot Button at the End */}
      <div className="flex justify-center mt-8 ">
      
      </div>
    </section>
  );
};

export default BannerSection;
